import { render, staticRenderFns } from "./tabPro.vue?vue&type=template&id=011f50d4"
import script from "./tabPro.vue?vue&type=script&lang=js"
export * from "./tabPro.vue?vue&type=script&lang=js"
import style0 from "../../../../../styles/updateProject.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports